import axiosInstance from "../utils/axios";

export type LicenseCheckoutRequest = {
	songIds: string[];
	producer: string;
	additionalLicensee?: string;
	production: string;
	email: string;
};

export type LicenseCheckoutResponse = {
	url: string;
	licenseId: string;
};

const checkoutLicense = async (request: LicenseCheckoutRequest): Promise<LicenseCheckoutResponse> => {
	try {
		const response = await axiosInstance.post<LicenseCheckoutResponse>('/license/checkout', request);
		return response.data;
	} catch (error: any) {
		const serverMessage = error?.response?.data?.error;
		throw new Error(serverMessage || 'Could not start checkout.');
	}
};

const licenseService = {
	checkoutLicense
};

export default licenseService;
